var Cube = (function(){

    function Cube(){
        THREE.Object3D.call(this);

        var geometry = new THREE.BoxGeometry(100, 100, 100, 10, 10, 10);
        var material = new THREE.MeshBasicMaterial({color: 0xeb4357, wireframe: true, transparent: true});
        this.mesh = new THREE.Mesh(geometry, material);
        this.add(this.mesh);

        material = new THREE.MeshLambertMaterial({color: 0xeb4357, shading: THREE.FlatShading, transparent: true});
        this.meshFull = new THREE.Mesh(geometry, material);
        this.add(this.meshFull);
        this.meshFull.position.y = -10000;

        this.tl = new TimelineMax();
        var v;
        for(var i = 0, l = this.meshFull.geometry.vertices.length; i < l; i++) {
            v = this.meshFull.geometry.vertices[i]
            this.tl.to(v, Math.random(), {
                x: v.x + Math.random() * 200 - 100,
                y: v.y + Math.random() * 200 - 100,
                z: v.z + Math.random() * 200 - 100,
                ease: Expo.easeOut
            }, i * 0.001);
        }
    }

    Cube.prototype = new THREE.Object3D;
    Cube.prototype.constructor = Cube;

    Cube.prototype.update = function() {
        this.rotation.x += 0.01;
        this.rotation.y += 0.01;
        this.meshFull.geometry.verticesNeedUpdate = true;
    };

    return Cube;
})();